export const DEFAULT_INITIALS_FOR_CANVAS = 'Default name';
export const STATUSES = {
    PLAYING: 'PLAYING',
    LOADING: 'LOADING',
    STOPPED: 'CLOSED',
    NOT_STARTED: 'NOT_STARTED'
};
export const WAITING_VIDEO_TIMEOUT = 200;
